import { get, post } from "./common/http";
import { BASE_URL } from "./common/const";
import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";

export const GetSaleDetail = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Sale/GetDetail?` + params, null);
export const GetCustomSaleDetail = (params: any) =>
   GET_ENC(`${BASE_URL}/api/CustomSale/GetCustomDetail?` + params, null);
export const GetCustomQuotatoinDetail = (params: any) =>
   GET_ENC(`${BASE_URL}/api/CustomQuotation/GetCustomDetailQuotation?` + params, null);

export const GetLastSaleDetail = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Sale/GetLastDetail?` + params, null);

export const GetSaleDetailForCredit = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Sale/GetSaleDetailForCredit?` + params, null);

export const GetSaleDetailByBuyerAndProduct = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Sale/GetSaleDetailByBuyer?` + params, null);

export const GetSaleList = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Sale/GetList?` + params, null);

export const GetSaleListByBuyer = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Sale/GetListByBuyer?` + params, null);

export const GetPrintInvoice = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Sale/GetPrintInvoice?` + params, null);

export const GetPrintProformaInvoice = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Report/GetPrintProformaInvoice?` + params, null);

export const GetPrintQuotationInvoice = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Report/GetPrintQuotationInvoice?` + params, null);

export const GetPrintLabourInvoice = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Labour/GetPrintLabourInvoice?` + params, null);

export const CreateSale = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Sale/Create`, data, true);
export const CreateCustomSale = (data: any) =>
  POST_ENC(`${BASE_URL}/api/CustomSale/CreateCustomSale`, data, true);
export const CreateCustomQuotation = (data: any) =>
  POST_ENC(`${BASE_URL}/api/CustomQuotation/CreateCustomQuotation`, data, true);


export const UpdateSale = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Sale/Update`, data, true);

export const UpdateCustomSale = (data: any) => 
  POST_ENC(`${BASE_URL}/api/CustomSale/UpdateCustomSale`, data, true); 

export const UpdateCustomQuotation = (data: any) =>
  POST_ENC(`${BASE_URL}/api/CustomQuotation/UpdateCustomQuotation`, data, true);


export const getInvoiceReportExportFile = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Sale/InvoiceExportFile?` + params, null);

export const GetStaffListForInvoice = (params: any) =>
   GET_ENC(`${BASE_URL}/api/staff/GetStaffListForInvoice?` + params, null);

export const GetProductListBySaleId = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Product/GetListBySaleId?` + params, null);

export const GetInvoiceNumber = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Sale/GetInvoiceNumber?` + params, null);

export const GetProformaInvoiceNumber = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Proforma/GetInvoiceNumber?` + params, null);

export const GetProformaDetail = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Proforma/GetDetail?` + params, null);

export const GetLastProformaDetail = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Proforma/GetLastDetail?` + params, null);

export const GetProformaList = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Proforma/GetList?` + params, null);

export const CreateProforma = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Proforma/Create`, data, true);

export const UpdateProforma = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Proforma/Update`, data, true);
export const CreateProformaLWH = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Proforma/CreateLWH`, data, true);

export const UpdateProformaLWH = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Proforma/UpdateLWH`, data, true);

export const DeleteProforma = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Proforma/Delete`, data);

export const GetSaleOrderDueList = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Proforma/SaleOrderDueList?` + params, null);

export const GetSaleOrderDueDetailByProduct = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Proforma/SaleOrderDueDetailByProduct?` + params, null);

export const GetQuotationInvoiceNumber = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Quotation/GetInvoiceNumber?` + params, null);

export const GetQuotationDetail = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Quotation/GetDetail?` + params, null);

export const GetLastQuotationDetail = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Quotation/GetLastDetail?` + params, null);

export const GetQuotationList = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Quotation/GetList?` + params, null);

export const CreateQuotation = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Quotation/Create`, data, true);

export const UpdateQuotation = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Quotation/Update`, data, true);

export const DeleteQuotation = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Quotation/Delete`, data);

export const GetLabourInvoiceNumber = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Labour/GetInvoiceNumber?` + params, null);

export const GetLabourDetail = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Labour/GetDetail?` + params, null);

export const GetLastLabourDetail = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Labour/GetLastDetail?` + params, null);

export const GetLabourList = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Labour/GetList?` + params, null);

export const CreateLabour = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Labour/Create`, data, true);
export const UpdateLabour = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Labour/Update`, data, true);

export const CreateLabourLWH = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Labour/CreateLWH`, data);

export const UpdateLabourLWH = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Labour/UpdateLWH`, data);

export const DeleteLabour = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Labour/Delete`, data);

export const GetSaleListForInvoiceReceipt = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Sale/GetSaleListForInvoiceReceipt?` + params, null);

export const GetQuotationDetailData = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Quotation/GetQuotationDetailData?` + params, null);

export const DeleteSale = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Sale/Delete`, data);

export const LockSale = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Sale/Lock`, data);

export const CancelSale = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Sale/Cancel`, data);

export const GetAdvancePaymentListForSale = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Sale/GetAdvancePaymentListForSale?` + params, null);

export const GetSaleSummaryBySalePerson = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Sale/SaleDetailbySaleperson?` + params, null);

export const GetSaleSummaryByCustomer = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Sale/GetSaleSummaryByCustomer?` + params, null);

export const GetSaleDetailsByCustomerWise = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Sale/GetSaleDetailsByCustomer?` + params, null);

export const GetSaleSummaryByProduct = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Sale/GetSaleSummaryByProduct?` + params, null);

export const GetSaleDetailsByProduct = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Sale/GetSaleDetailsByProduct?` + params, null);

export const GetSaleSummarybySalepersonView = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Sale/SaleSummarybySaleperson?` + params, null);

export const GetSaleReturn = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Sale/SaleReturn?` + params, null);

export const GetDailySale = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Sale/DailySale?` + params, null);


export const GetSaleDetailQtyAdjList = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Sale/SaleDetailQtyAdjList?` + params, null);

export const SendMultipleEmail = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Sale/SendMultipleEmail`, data, true);

export const GetMultipleInvoicePrint = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Report/GetInvoicePrintMultiple`, data, true);

export const GetSaleSummaryByCustomerAndProduct = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Sale/GetSaleSummaryByCustomerAndProduct?` + params, null);

export const GetTransportInvoiceReport = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Sale/GetTransportInvoiceReport?` + params, null);

